// @ts-nocheck
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  HostBinding,
  HostListener,
  AfterViewInit,
  ViewEncapsulation,
  ChangeDetectorRef,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter
} from '@angular/core';
import * as d3 from "d3";

import { IconChartComponent } from '../iconEvent-chart/icon-chart.component';
import { NewFilterService } from 'src/app/services/new-filter.service';
import { FilterService } from 'src/app/services/filter.service';
import { Subscription } from 'rxjs';
import { RouterHandlerService } from 'src/app/services/router-handler.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ActivatedRoute, Router } from '@angular/router';


// import patientJourneyData from "src/app/components/shared/charts/pixel-map/patient_journey_data_super_shortened.json"
// import journeyStopData from "src/app/components/shared/charts/pixel-map/sequencing_min_stat_source_cnt.json";

export interface FlowData {
    pat_seq_sub_cat_key: number;
    sub_category_desc: string;
    starting_point: string;
    stop_point: string;
    pat_count: number;
}
1
export interface FlowHierarchyNode {
    name: string;
    children?: FlowHierarchyNode[];
    volume?: number;
    group?: string;
    targets?: string[]; // For leaf nodes to know where they go
    key?: string; // Unique key for linking
    pat_seq_sub_cat_key?: number; // Added for selection
    [key: string]: any;
}

@Component({
  selector: 'app-chord-chart',
  templateUrl: './chord-chart.component.html',
  styleUrls: ['./chord-chart.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChordChartComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  // ===================================================================
  // Component Properties
  // ===================================================================

  // A reference to the chart's container element in the template.
  @ViewChild('ChordChartContainer') ChordChartContainer: ElementRef;
  @ViewChild('fs') fs: ElementRef;


  @ViewChild(IconChartComponent) iconChart!: IconChartComponent;
  @Input('item') item: any
  @Input('type') type: any
  @Input('data') data: any
  @Input('columnDetails') columnDetails: any
  @Input('config') config: any
  @Input('heading') heading: string = ''
  @Input('pageKey') pageKey: any
  isLoading = false;
  @Input('error_name') error_name: any;
  @Output() filterChange = new EventEmitter<any>();
  @HostBinding('class.is-fullscreen') isFullscreen = false;
  reqSubcription: Subscription[] = [];

  moduleName: any;
  cardName: any;

  divId: any = "ChordChartDiv";
  iconList: any;
  @Input() isActive = false;
  props: any = {};
  initialChartWidth: any;
  cardWidthWithoutScrolling: any;
  noData: boolean = false;

  cfg: any = {};
  edge_bundling: boolean = false;

  // Holds the transformed data ready for D3 to use.
  private processedData: any[];
  // Holds the unique list of all possible statuses for the matrix y-axis.
  private sets: string[];
  // Holds the total number of unique patients for percentage calculations.
  private totalPatients: number;
  // Tracks which bars are currently selected by the user.
  private selectedBars = new Set<string>();
  // Tracks which ribbons are currently selected by the user.
  private selectedRibbons = new Set<number>();

  // Controls the expanded state of the chart for the "Show More" feature.
  public showMore = false;
  // Determines if the "Show More" button should be visible.
  public isOverflowing = false;
  // track filtered state
  private isFiltered = false;

  private componentId: string;
  private componentId: string;
  // private patientIdFilter: Set<string> | null = null; // Stores patient IDs from the other chart
  private otherChartFilters = new Map<string, any>(); 


  private yAxisTitle: d3.Selection<SVGTextElement, unknown, null, undefined>;
  private ribbonSelection: d3.Selection<SVGPathElement, any, SVGGElement, unknown>;
  private textSelection: d3.Selection<SVGTextElement, any, SVGGElement, unknown>;
  private arcSelection: d3.Selection<SVGPathElement, any, SVGGElement, unknown>;
  private colorScale: any;


// settings
    public showLabels = true;


  // styles
  private ribbonOpacity: number = .5;

  // Arc click filter state - stores the selected source name for filtering
  private selectedSourceFilter: string | null = null;
  // NEW: Multi-select support
  public selectedArcs = new Set<string>();
  public isFocused = false;

  // Master color scale - preserved across filter operations for color consistency

  private masterColorScale: d3.ScaleOrdinal<string, string> | null = null;
  
  async stop(ms: number): Promise<void> {
    return new Promise<void>(resolve => setTimeout(resolve, ms));
  }
  start() { this.isLoading = true;}

  constructor(
    private cdr: ChangeDetectorRef,
    private newFilterService: NewFilterService,
    public filterService: FilterService,
    private route: ActivatedRoute,
    private routerHandlerService: RouterHandlerService,
    private navigationService: NavigationService) {
    this.filterService.changeDisplays.subscribe((res: any) => {
      // gets the value of the selected toggle from the icon chart 
      if (this.item.config.report_heading == "Sources") {
        this.changeDisplayType(res);
      }
    });

    // This is used for setting up the route to the pixel map
    this.route.params.subscribe((p: any) => {
      this.queryParams = p;
      this.moduleName = p['module'] || '';

      this.route.queryParams.subscribe((params: any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"];
      });
    });
  }

  // ===================================================================
  // Angular Lifecycle Hooks
  // ===================================================================

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      console.log('[ChordChart] Data changed, reprocessing...');
      
      // Check if data is valid
      if (!this.data || !Array.isArray(this.data) || this.data.length === 0) {
        this.noData = true;
        this.processedData = [];
        if (this.ChordChartContainer) {
            d3.select(this.ChordChartContainer.nativeElement).selectAll('*').remove();
            this.svg = null;
            this.arcGroup = null;
            this.ribbonGroup = null;
            this.labelGroup = null;
        }
        this.isLoading = false;
        return;
      }
      
      this.noData = false;
      
      if (this.matrixYaxisVar == "JOURNEY_STOP") {
        this.processJourneyStopData();
      } else {
        this.processData();
      }
      
      // Choose render method
      this.redraw();
    }
  }

  // Helper to choose the correct render method
  public redraw(): void {
        this.cfg = this.item?.['config'];
        this.edge_bundling = this.cfg?.edge_bundling?.value == 'true';
        
        if (this.edge_bundling) {
            this.createBundleChart();
        } else {
            this.drawChart();
        }
  }

  ngOnInit(): void {

    this.start();
    // console.log(journeyStopData);
    // Process the raw data once when the component is initialized.
    this.iconList = this.item?.config.icon ? this.item?.config.icon : this.iconList

    // Make sure we are subscribed to chart changes. Needed for our double chordChart dashboard
    this.componentId = `${this.item?.config?.report_heading}:${Math.random()} `

    this.reqSubcription.push(
      this.newFilterService.chordChartFilteredData.subscribe((payload: any) => {
        // when here we only want to refresh other charts
        if (payload && payload.senderId !== this.componentId) {
          // Store the keys from the other chart
          // this.patientIdFilter = payload.data;
          const key_name = payload.key_name;

          if (payload.data) {
             this.otherChartFilters.set(key_name, payload.data);
          } else {
             this.otherChartFilters.delete(key_name);
          }
          
          //z Reprocess and redraw this chart with the filtered data
          // We might want to emit the combined state or just the new change. 
          // Previous code emitted just the new change:
          this.filterChange.emit({ [key_name]: payload.data });
          
          // clear the selected ribbons
          this.selectedRibbons.clear();
        }
      }));


    this.matrixYaxisVar = this?.item?.config?.y_axis ?? "CURRENT_REFERRAL_STATUS";

    // Initial processing
    if (this.matrixYaxisVar == "JOURNEY_STOP") {
      this.processJourneyStopData();
    } else {
      this.processData();
    }
  }

  ngAfterViewInit(): void {
    // Perform the initial chart render after the view (and #chartContainer) is ready.
    this.setupChart();
    this.drawChart();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    // Redraw the chart whenever the window is resized to keep it responsive.
    // Redraw the chart whenever the window is resized to keep it responsive.
    this.redraw();
  }


  @HostListener('fullscreenchange', ['$event'])
  @HostListener('webkitfullscreenchange', ['$event'])
  @HostListener('mozfullscreenchange', ['$event'])
  @HostListener('MSFullscreenChange', ['$event'])
  screenChange(event: any) {
    if (!document.fullscreenElement) {
      this.closeFullscreen();
    }
  }
  closeFullscreen(): void {
    this.isFullscreen = false;
    this.props.chartHeight = 400
    this.cardWidthWithoutScrolling = this.initialChartWidth;
    this.isActive = false;

    // if (document.exitFullscreen) {
    //   document.exitFullscreen();
    // } 
    setTimeout(() => {
    setTimeout(() => {
      this.redraw();
    }, 100);
    }, 100);
  }

  openFullscreen(): void {
    this.isFullscreen = true;
    const el = this.fs.nativeElement;
    if (
      !document.fullscreenElement && // alternative standard method
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (el.requestFullscreen) {
        el.requestFullscreen();
      } else if (el.mozRequestFullScreen) {
        el.mozRequestFullScreen();
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (el.msRequestFullscreen) {
        el.msRequestFullscreen();
      }
    }
    setTimeout(() => {
      this.isActive = true;
      this.isFullscreen = true;
      this.redraw();
    }, 500);
    setTimeout(() => { }, 500);
  }

  changeDisplayType(selectedType: any) {
    this.matrixYaxisVar = selectedType;
    if (this.matrixYaxisVar == "JOURNEY_STOP") {
      this.processJourneyStopData();
    }
    else {
      this.processData();
    }
    this.redraw();
    // this.changeChartTheme(selectedType);
  }

  // ===================================================================
  // Public Component Methods (for the template)
  // ===================================================================

  /**
   * Toggles the expanded state of the chart and triggers a redraw.
   */
  public toggleShowMore(): void {
    this.showMore = !this.showMore;
    this.drawChart();
  }


  public toggleShowMore(): void {
    this.showMore = !this.showMore;
    this.redraw();
  }


  // --- Interactive Tooltip State ---
  public interactionTooltipData = {
    visible: false,
    source: '',
    targets: [] as { name: string, selected: boolean }[],
    x: 0,
    y: 0
  };
  
  private clickTimer: any = null;
  
  // Drag State
  private isDragging = false;
  private dragOffset = { x: 0, y: 0 };

  public handleArcClick(event: any, d: any): void {
      event.stopPropagation();
      const source = d.data || d; // Handle d3 vs direct string if needed

      if (this.clickTimer) {
          // DOUBLE CLICK DETECTED
          clearTimeout(this.clickTimer);
          this.clickTimer = null;
          
          // Action: Open Tooltip
          this.openInteractionTooltip(event, source);
      } else {
          // SINGLE CLICK? Wait for potential second click
          this.clickTimer = setTimeout(() => {
              this.clickTimer = null;
              
              // Action: Toggle Selection
              if (this.selectedArcs.has(source)) {
                  this.selectedArcs.delete(source);
              } else {
                  this.selectedArcs.add(source);
              }
              
              this.hideTooltip();
              this.redraw();
          }, 250); 
      }
  }

  public openInteractionTooltip(event: any, sourceName: string): void {
      // 1. Identify all targets connected to this source
      const targets = new Set<string>();
      
      this.processedData.forEach(d => {
          if (d.starting_point === sourceName) {
             if (d.sub_category_desc) {
                 d.sub_category_desc.split(',').forEach(t => {
                     const trimmed = t.trim();
                     if (trimmed !== sourceName) targets.add(trimmed);
                 });
             }
          }
      });

      // 2. Prepare data
      let x = event.pageX;
      let y = event.pageY;

      // Use relative coordinates if possible, matching the container
      if (this.fs?.nativeElement) {
          const coords = d3.pointer(event, this.fs.nativeElement);
          x = coords[0];
          y = coords[1];
      }
      
      // Ensure it doesn't go off screen (basic clamp)
      const maxX = (this.fs?.nativeElement?.offsetWidth || 800) - 300; // width of tooltip
      if (x > maxX) x = maxX;
      if (y < 20) y = 20;

      this.interactionTooltipData = {
          visible: true,
          source: sourceName,
          targets: Array.from(targets).sort().map(t => ({ name: t, selected: true })), 
          x: x, 
          y: y
      };

      // 3. Highlight initially (all selected)
      this.updateDetailedHighlight();
      
      // Stop propagation to prevent accidental closing
      event.stopPropagation();
  }

  public closeInteractionTooltip(): void {
      this.interactionTooltipData.visible = false;
      this.resetHighlight(); // Restore normal chart state
  }

  public toggleInteractionTarget(target: { name: string, selected: boolean }): void {
      target.selected = !target.selected;
      this.updateDetailedHighlight();
  }
  
  public toggleAllInteractionTargets(): void {
      const allSelected = this.interactionTooltipData.targets.every(t => t.selected);
      // If ALL are selected, turn them FALSE.
      // If SOME or NONE are selected, turn them TRUE.
      const newState = !allSelected;
      
      this.interactionTooltipData.targets.forEach(t => t.selected = newState);
      this.updateDetailedHighlight();
  }

  // --- Dragging Logic ---
  public startDrag(event: MouseEvent): void {
      if (event.button !== 0) return; // Only left click
      this.isDragging = true;
      this.dragOffset.x = event.clientX - this.interactionTooltipData.x;
      this.dragOffset.y = event.clientY - this.interactionTooltipData.y;
      event.preventDefault(); // Prevent text selection
  }

  @HostListener('document:mousemove', ['$event'])
  public onDrag(event: MouseEvent): void {
      if (!this.isDragging) return;
      
      // Calculate new position relative to the initial offset
      // Just update x/y directly? 
      // Wait, interactionTooltipData.x/y are used for [style.left.px].
      // But these are relative to the container usually?
      // Ah, if we used d3.pointer before, that was relative to container.
      // But event.clientX is global.
      // We need to maintain the *coordinate system* of the container.
      // Easiest way: Calculate delta from start.
      
      // Let's rethink startDrag:
      // We can just track movement delta.
      // But if we want absolute position update:
      // We need to know where the mouse is relative to the *container* again?
      // Actually, if we use the offset approach:
      // New X (relative to container) = MouseX (global) - ContainerX (global) - Offset inside tooltip.
      // Since container is relative, this is complex if we don't know container global pos.
      
      // Simpler approach: 
      // Use existing x/y as base.
      // On start, record mouseX, mouseY.
      // On move, deltaX = currentMouseX - startMouseX. startMouseX = currentMouseX.
      // Update this.interactionTooltipData.x += deltaX.
      
      // Refined Logic (implemented below)
      if (this.isDragging) {
           // We need to calculate the change since the last frame?
           // Or just track raw mouse pos.
           // Let's rely on the fact that we can get pointer relative to container easily IF we have the container.
           if (this.fs?.nativeElement) {
               const coords = d3.pointer(event, this.fs.nativeElement);
               // We want the topleft of the tooltip to be at coords - internal_offset
               // But calculating internal offset is hard without event.offsetX/Y relative to tooltip.
               
               // Let's use the delta approach. It's safer.
               // We need `lastMouseX/Y` state.
           }
      }
  }

  @HostListener('document:mouseup', ['$event'])
  public endDrag(event: MouseEvent): void {
      this.isDragging = false;
  }
  
  // Re-implementing start/drag with Delta logic for simplicity
  private lastDragPos = { x: 0, y: 0 };
  
  public startDragActual(event: MouseEvent): void {
      this.isDragging = true;
      this.lastDragPos = { x: event.clientX, y: event.clientY };
  }
  
  @HostListener('document:mousemove', ['$event'])
  public onDragActual(event: MouseEvent): void {
      if (!this.isDragging) return;
      
      const dx = event.clientX - this.lastDragPos.x;
      const dy = event.clientY - this.lastDragPos.y;
      
      this.interactionTooltipData.x += dx;
      this.interactionTooltipData.y += dy;
      
      this.lastDragPos = { x: event.clientX, y: event.clientY };
  } 

  // --- Select Button Logic ---

  private getMatchingRibbonKeys(): number[] {
      const activeSource = this.interactionTooltipData.source;
      const allowedSet = new Set<string>();
      allowedSet.add(activeSource);
      this.interactionTooltipData.targets.forEach(t => {
          if (t.selected) allowedSet.add(t.name);
      });

      const matchingKeys: number[] = [];

      // Iterate through processedData to find exact matches
      // Note: We need to access the raw data or ribbon data.
      // processedData is available.
      this.processedData.forEach((row: any) => {
          // 1. Must start from active source
          if (row.starting_point !== activeSource) return;

          // 2. Construct Journey Set
          const journeySet = new Set<string>();
          journeySet.add(row.starting_point);
          if (row.sub_category_desc) {
              row.sub_category_desc.split(',').forEach((s: string) => journeySet.add(s.trim()));
          }

          // 3. Strict Equality Check
          if (journeySet.size !== allowedSet.size) return;
          
          let match = true;
          for (const entity of journeySet) {
              if (!allowedSet.has(entity)) {
                  match = false;
                  break;
              }
          }

          if (match) {
              matchingKeys.push(row.pat_seq_sub_cat_key);
          }
      });
      
      return matchingKeys;
  }

  public get canSelectInteraction(): boolean {
      // Just check if any keys match
      return this.getMatchingRibbonKeys().length > 0;
  }

  public confirmInteractionSelection(): void {
      const keys = this.getMatchingRibbonKeys();
      if (keys.length === 0) return;

      // Add to global selection
      keys.forEach(k => this.selectedRibbons.add(k));
      
      // Update chart visuals
      this.redraw();
      
      // Close tooltip and reset temporary highlight (which will show the persistent selection now)
      this.closeInteractionTooltip();
  }

  private updateDetailedHighlight(): void {
      if (!this.ribbonSelection) return;
      const activeSource = this.interactionTooltipData.source;
      
      // Construct the Set of ALL allowed entities (Source + Selected Targets)
      const allowedSet = new Set<string>();
      allowedSet.add(activeSource);
      this.interactionTooltipData.targets.forEach(t => {
          if (t.selected) allowedSet.add(t.name);
      });

      this.ribbonSelection
      
      // Helper to check match
      const isMatch = (d: any) => {
           // Handle Ribbon (sourceName) vs Node (data.group)
           const source = d.sourceName || d.data?.group;
           if (source !== activeSource) return false;
           
           const journeySet = new Set<string>();
           journeySet.add(d.data.starting_point);
           if (d.data.sub_category_desc) {
               d.data.sub_category_desc.split(',').forEach((s: string) => journeySet.add(s.trim()));
           }
           
           if (journeySet.size !== allowedSet.size) return false;
           for (const entity of journeySet) {
               if (!allowedSet.has(entity)) return false;
           }
           return true;
      };

      this.ribbonSelection
          .style('opacity', (d: any) => isMatch(d) ? 0.9 : 0.1)
          .style('stroke', (d: any) => isMatch(d) ? '#000000' : null)
          .style('stroke-width', (d: any) => isMatch(d) ? 3 : null);
          
      // Dim Arcs/Text that are not in the allowed set
      if (this.arcSelection) {
          this.arcSelection.style('opacity', (d: any) => {
              // Handle both Bundle (d.data.name) and Standard (d.data) data structures
              const name = d.data?.name || d.data;
              if (allowedSet.has(name)) return 1;
              return 0.1;
          });
      }
      
       if (this.textSelection) {
          this.textSelection.style('opacity', (d: any) => {
              const name = d.data?.name || d.data;
              if (allowedSet.has(name)) return 1;
              return 0.1;
          });
      }

      if (this.nodeSelection) {
          this.nodeSelection.style('opacity', (d: any) => {
              // Standard Chord doesn't usually use detailed highlight for bars this way, 
              // but Bundle Chart does.
              // Check if node matches the specific journey
              if (isMatch(d)) return 1;
              return 0.1;
          });
      }
  }

  /**
   * When the user clicks "Filter", the behavior depends on which chart this is.
   */
  public filterData(): void {
    if (this.selectedArcs.size === 0 && this.selectedRibbons.size === 0) return;

    // Use a Set to collect unique keys from BOTH selections
    const keysToBroadcast = new Set<string>();

    // 1. Add keys from explicitly selected ribbons
    this.selectedRibbons.forEach(key => keysToBroadcast.add(key));

    // 2. Add keys from selected Arcs (Sources)
    if (this.selectedArcs.size > 0) {
        // Find all rows where the starting point is a selected arc
        // Or where the arc is part of the destination (conceptually, though usually we filter by source)
        // Based on "highlightArc", we care about connections. 
        // Typically in this chart, filtering by Arc means "Show me journeys starting here".
        
        this.processedData.forEach(row => {
            if (this.selectedArcs.has(row.starting_point)) {
                keysToBroadcast.add(row.pat_seq_sub_cat_key);
            }
        });
    }

    if (keysToBroadcast.size > 0) {
        const selectedKeys = Array.from(keysToBroadcast).join(',');
        
        // Use dynamic key from config or fallback
        const filterKey = this.item.config?.sub_cat_key || 'pat_seq_sub_cat_key';

        // Emit the keys to the parent card component
        this.filterChange.emit({ [filterKey]: selectedKeys });
        
        // Broadcast keys to other charts
        this.sendPatientFilter(selectedKeys, filterKey);
    }
  }

  /**
   * ✅ New private helper method to find matching patient IDs based on the current selections.
   * This avoids duplicating code for both the 'Sources' and 'Statuses' charts.
   * @returns A Set of patient IDs that match the selected bar combinations.
   */
  private findMatchingPatientIds(): Set<string> {
    const selectedCombinations = new Set(Array.from(this.selectedBars));
    const matchingPatientIds = new Set<string>();
    const patientValueSets = new Map<string, Set<string>>();
    const dataField = this.matrixYaxisVar; // The field to group by (e.g., 'SOURCE_NAME')

    // 1. Group the relevant data (statuses or sources) for each patient in the raw dataset.
    // 1. Group the relevant data (statuses or sources) for each patient in the raw dataset.
    // Check if `this.data` exists AND has the expected structure for Patient Journey data.
    const isDynamicDataValid = this.data && this.data.length > 0 && 'LH_PATIENT_ID' in this.data[0];
    const rawData = isDynamicDataValid ? this.data : patientJourneyData;

    rawData.forEach((record: any) => {
      // Apply the same deterministic "fluffing" filter here so filtering matches the chart.
      if (!this.shouldIncludeRecord(record)) return;

      const value = record[dataField];
      if (value) {
        if (!patientValueSets.has(record.LH_PATIENT_ID)) {
          patientValueSets.set(record.LH_PATIENT_ID, new Set());
        }
        patientValueSets.get(record.LH_PATIENT_ID).add(value);
      }
    });

    // 2. Check each patient's combination of values against the user's selections.
    patientValueSets.forEach((values, patientId) => {
      let key;
      // This logic MUST match the key generation in processData() to find a match.
      if (dataField === 'CURRENT_REFERRAL_STATUS') {
        const customStatusOrder = ['PENDING', 'CANCELLED', 'CANCELLED - TRANSITION', 'ACTIVE', 'DISCONTINUED', 'QUICK START', 'PAP', 'IAP', 'INACTIVE', 'NURSING'];
        key = Array.from(values).sort((a, b) => {
          const indexA = customStatusOrder.indexOf(a);
          const indexB = customStatusOrder.indexOf(b);
          if (indexA === -1) return 1; if (indexB === -1) return -1;
          return indexA - indexB;
        }).join('-');
      } else {
        key = Array.from(values).sort().join('-');
      }

      // If the patient's combination key is in the set of selected bars, add their ID.
      if (selectedCombinations.has(key)) {
        matchingPatientIds.add(patientId);
      }
    });

    return matchingPatientIds;
  }

  /**
   * Resets this chart and tells the other chart to reset its filter.
   */
  public resetChart(): void {
    this.selectedBars.clear();
    this.selectedRibbons.clear(); // Clear ribbon selection
    this.selectedArcs.clear(); // Clear arc selection
    this.isFocused = false;    // Reset focus mode
    this.isFiltered = false;
    this.showMore = false;

    // Reset the arc click filter (legacy, but good to ensure cleared)
    this.selectedSourceFilter = null;

    // Reset the filter that this chart might have received from the other chart.
    // this.patientIdFilter = null;
    this.otherChartFilters.clear();

    // Tell the other chart to reset its filter as well.
    const filterKey = this.item.config?.sub_cat_key || 'pat_seq_sub_cat_key';
    this.sendPatientFilter(null, filterKey);

    // Emit null to clear parent API filter
    this.filterChange.emit({ pat_seq_sub_cat_key: null });

    // CRUCIAL: Reprocess the data using the full, original dataset.
    this.processData();

    // Now, redraw the chart with the reprocessed, full data.
    this.redraw();
    this.cdr.detectChanges();
  }
  
  public goToPixelMap(event): void {
    console.log("arrow clicked");

    // Start with the other charts' filters
    let combinedPayload: any = {};
    
    // Merge filters from other charts
    this.otherChartFilters.forEach((value, key) => {
        combinedPayload[key] = value;
    });

    // Add current chart's selection if any
    if (this.selectedRibbons.size > 0) {
        // Pass the selected keys directly
        const currentKeys = Array.from(this.selectedRibbons).join(',');
        const myKey = this.item.config?.sub_cat_key || 'pat_seq_sub_cat_key';
        combinedPayload[myKey] = currentKeys;
    }
    
    // Only navigate if we have something to send? 
    // Or allow navigation even if empty (maybe passing empty object)?
    // Original code checked `if (this.selectedRibbons.size > 0)`.
    // Now we should check if `combinedPayload` has any keys.
    
    if (Object.keys(combinedPayload).length > 0) {
        this.NavigationArrow('chart', combinedPayload, event.offsetX, event.offsetY, 500)
    }
  }

  private NavigationArrow(myType: any, myData: any, myX: any, myY: any, chartWidth: any): void {
    // Navigation taken from horizontal-bar-chart.component.ts
    const conf0 = this.item.config?.['nav_configuration'].controls[0]
    let nav = {
      dbJSON: conf0.dbJSON,
      s3JSON: conf0.s3JSON,
      pageName: conf0.pageName,
      isDashboardLevel: conf0.isDashboardLevel
    }

    // let payload:any ={[conf0.payloadData]:conf0.payloadData=='column_key'? myData[0].AllData[0][conf0.payloadData] : myData[0].range }
    
    let payload;
    // Check if myData is already a payload object (not an array)
    if (typeof myData === 'object' && !Array.isArray(myData) && myData !== null) {
        // It's already the map of keys
        payload = myData;
        // Also ensure current chart's default key is present if needed? 
        // It should be in the map already from goToPixelMap logic.
    } else {
        // Legacy fallback
        payload = { [conf0?.payloadData]: Array.isArray(myData) ? myData.join(',') : myData };
    }
    
    this.routerHandlerService.navDetailInfo(nav);
    this.routerHandlerService.storingPayloadAndFilterForGrid(conf0, payload, '');

    let query: any = Object.assign({}, this.decryptedParams, { tab_id: 0 }, { page: 'card' });
    let queryMaped = this.navigationService.movePropertyToFirst(query, 'tab_id');
    this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${nav.pageName}`, queryMaped);
  }

  /**
   * Generates the text for the selection counter display.
   * @returns A formatted string like "2 Archetypes Selected".
   */
  public getSelectionText(): string {
    const count = this.selectedBars.size;
    
    // Check ribbons too
    const ribbonCount = this.selectedRibbons.size;
    if (ribbonCount > 0) {
        return `${ribbonCount} Journey(s) Selected`;
    }

    // Check arcs
    if (this.selectedArcs.size > 0) {
        const noun = this.selectedArcs.size === 1 ? 'Source' : 'Sources';
        return `${this.selectedArcs.size} ${noun} Selected`;
    }

    if (count === 0) {
      return '';
    }
    const noun = count === 1 ? 'Archetype' : 'Archetypes';
    return `${count} ${noun} Selected`;
  }

  public applyFocus(): void {
      if (this.selectedArcs.size === 0) return;
      this.isFocused = true;
      this.redraw();
  }

  /**
   * Broadcasts a payload (set of patient IDs OR ribbon keys string) to other components.
   */
  sendPatientFilter(payloadData: any, key_name: string): void {
    const payload = {
      senderId: this.componentId,
      data: payloadData,
      key_name: key_name
    };
    this.newFilterService.chordChartFilteredData.next(payload);
  }

  setupChart(): void {
    const element = this.ChordChartContainer.nativeElement;
    d3.select(element).selectAll('*').remove();
    
    // Reset SVG references so a fresh SVG will be created on next draw
    this.svg = null;
    this.arcGroup = null;
    this.ribbonGroup = null;
    this.labelGroup = null;

    this.cfg = this.item?.['config'];
    this.edge_bundling = this.cfg.edge_bundling.value == 'true' 
    

    const margin = { top: 0, right: 30, bottom: 0, left: 160 };
  }

  // ===================================================================
  // Data Processing Method
  // ===================================================================

  /**
   * Processes the raw patient journey data into a format suitable for the UpSet chart.
   * This method runs only once.
   */

  /**
   * Helper to deterministically filter records for "Journey Stop" view to create variety.
   * Returns true if the record should be included.
   */
  private shouldIncludeRecord(record: any): boolean {
    // Only apply this logic for Journey Stop view
    if (this.matrixYaxisVar !== 'JOURNEY_STOP') return true;

    const patientId = parseInt(record.LH_PATIENT_ID, 10);
    const stop = record.JOURNEY_STOP;

    // Always keep HUB
    if (stop === 'HUB') return true;

    // Deterministic logic based on patient ID
    // Group 0 (33%): Keep everything
    // Group 1 (33%): Drop 'Non-COMMERCIAL SPs'
    // Group 2 (33%): Drop 'COMMERCIAL SPs'
    const group = patientId % 3;

    if (group === 1 && stop === 'Non-COMMERCIAL SPs') return false;
    if (group === 2 && stop === 'COMMERCIAL SPs') return false;

    return true;
  }

  processData(): void {
      if (!this.data || !Array.isArray(this.data)) return;

      // 1. Process Data & Aggregate (Strict Normalization)
      const aggregatedMap = new Map<string, FlowData>();
      
      // Helper for strict normalization (Uppercase + Clean Spaces)
      const normalize = (s: string) => s ? s.trim().toUpperCase().replace(/\s+/g, ' ') : '';

      this.data.forEach((d: any) => {
          const start = normalize(d.starting_point);
          let desc = normalize(d.sub_category_desc);
          
          const parts = desc ? desc.split(',').map(s => s.trim()) : [];
          // Filter out the start point from targets (Star Topology)
          const targets = parts.filter(s => s !== start);
          
          // Reconstruct normalized key
          const normalizedDescKey = targets.length > 0 ? targets.sort().join(',') : start;
          const key = `${start}|${normalizedDescKey}`;

          if (aggregatedMap.has(key)) {
              const existing = aggregatedMap.get(key)!;
              existing.pat_count += d.pat_count;
          } else {
              aggregatedMap.set(key, { ...d, starting_point: start, sub_category_desc: desc } as FlowData);
          }
      });

      this.processedData = Array.from(aggregatedMap.values());
      // Sort by count for consistent rendering
      this.processedData.sort((a, b) => b.pat_count - a.pat_count);
  }

  // ===================================================================
  // D3 Rendering Method
  // ===================================================================

  // Store references for persistent SVG elements
  private svg: d3.Selection<SVGSVGElement, unknown, null, undefined> | null = null;
  private arcGroup: d3.Selection<SVGGElement, unknown, null, undefined> | null = null;
  private ribbonGroup: d3.Selection<SVGGElement, unknown, null, undefined> | null = null;
  private labelGroup: d3.Selection<SVGGElement, unknown, null, undefined> | null = null;
  private outerBarGroup: d3.Selection<SVGGElement, unknown, null, undefined> | null = null;


  // Transition duration in milliseconds
  private transitionDuration = 600;

  /**
   * Handles all D3 logic for drawing and updating the chart.
   * Uses D3 update pattern with animated transitions for smooth morphing between states.
   */
  drawChart(): void {
      if (!this.ChordChartContainer || !this.processedData?.length) return;

      const element = this.ChordChartContainer.nativeElement;
      
      // Get width from the container element, use height equal to width for square chart
      const containerWidth = element.offsetWidth || 800;
      // const width = containerWidth;
      // const height = containerWidth; // Keep it square unless in full screen
      const width = 800;
      const height = 800; // Keep it square unless in full screen
      
      // Reduce outer radius slightly to make room for outer bars (approx 60px reserved)
      const outerRadius = Math.min(width, height) * 0.5 - 160; 
      const innerRadius = outerRadius - 30;


      this.ribbonOpacity = .5;
      const selectedOpacity = 0.9;


      // --- Prepare Entities & Flows ---
      const entityFlows = new Map<string, number>();
      const entities = new Set<string>();
      

      let dataWithIds = this.processedData.map((d, i) => ({ ...d, uniqueId: `journey-${i}` }));

      // Apply source filter if Focus is active
      if (this.isFocused && this.selectedArcs.size > 0) {
          if (this.selectedArcs.size === 1) {
             // Single selection: strict 'starts with' to match legacy behavior
             const singleSource = this.selectedArcs.values().next().value;
             dataWithIds = dataWithIds.filter(d => d.starting_point === singleSource);
          } else {
             // Multi selection: AND operation (intersection)
             // Keep journeys that include ALL selected arcs
             dataWithIds = dataWithIds.filter(d => {
                  const journeyEntities = new Set<string>();
                  journeyEntities.add(d.starting_point);
                  if (d.sub_category_desc) {
                      d.sub_category_desc.split(',').forEach(s => journeyEntities.add(s.trim()));
                  }
                  
                  // Check if ALL selected entities are present in this journey
                  for (const selected of this.selectedArcs) {
                      if (!journeyEntities.has(selected)) return false;
                  }
                  return true;
             });
          }
      }

      // 1. Collect ALL entities (Sources + Destinations) for Layout
      dataWithIds.forEach(d => {
          if (d.starting_point) entities.add(d.starting_point);
          if (d.sub_category_desc) {
              d.sub_category_desc.split(',').forEach(s => entities.add(s.trim()));
          }
      });

      // 1. Collect ALL entities (Sources + Destinations) for Layout
      dataWithIds.forEach(d => {
          if (d.starting_point) entities.add(d.starting_point);
          if (d.sub_category_desc) {
              d.sub_category_desc.split(',').forEach(s => entities.add(s.trim()));
          }
      });

      // 2. Identify Valid Sources (for visibility)
      const validSources = new Set<string>();
      dataWithIds.forEach(d => {
          if (d.starting_point) validSources.add(d.starting_point);
      });

      // 3. Calculate Flows & Enforce Min Size
      entities.forEach(e => entityFlows.set(e, 0));
      let totalGraphVolume = 0;
      dataWithIds.forEach(d => {
          const current = entityFlows.get(d.starting_point) || 0;
          entityFlows.set(d.starting_point, current + d.pat_count);
          totalGraphVolume += d.pat_count;
      });

      const minSize = totalGraphVolume * 0.005; 
      entities.forEach(e => {
          if ((entityFlows.get(e) || 0) < minSize) entityFlows.set(e, minSize);
      });

      // Sort entities by patient count descending (highest first)
      // This ensures sources with highest volume appear at the top and decrease clockwise
      const names = Array.from(entities).sort((a, b) => {
          const flowA = entityFlows.get(a) || 0;
          const flowB = entityFlows.get(b) || 0;
          return flowB - flowA; // Descending order
      });

      // --- Generate Arcs ---
      // Start at exactly 12 o'clock (-π/2 radians) and go clockwise
      const pie = d3.pie<string>()
          .value(d => entityFlows.get(d)!)
          .sort(null) // Preserve our custom sort order (descending by count)
          .startAngle(0) // 12 o'clock position
          .endAngle(0 + 2 * Math.PI) // Full circle clockwise
          .padAngle(0);

      const arcData = pie(names);
      const arcMap = new Map<string, any>();
      arcData.forEach(d => arcMap.set(d.data, d));

      // Only update the master color scale when NOT filtering
      // Prevent update if we are in Focus mode, so we keep original colors
      if (!this.selectedSourceFilter && !this.isFocused) {
          this.masterColorScale = d3.scaleOrdinal(d3.schemeCategory10).domain(names);
      }
      this.colorScale = this.masterColorScale || d3.scaleOrdinal(d3.schemeCategory10).domain(names);

      // Arc generator
      const arc = d3.arc<any>()
          .innerRadius(innerRadius)
          .outerRadius(outerRadius);

      // --- Create or get SVG ---
      // --- Create or get SVG ---
      // Robust check: if any part is missing, re-create everything
      if (!this.svg || !this.arcGroup || !this.ribbonGroup || !this.labelGroup) {
          d3.select(element).selectAll('*').remove();
          
          this.svg = d3.select(element)
              .append('svg')
              .attr('viewBox', [-width / 2, -height / 2, width, height] as any)
              .style('font', '12px sans-serif')
              .style('width', '100%')
              .style('height', 'auto');
          
          this.arcGroup = this.svg.append('g').attr('class', 'arcs');
          this.ribbonGroup = this.svg.append('g').attr('class', 'ribbons');
          this.labelGroup = this.svg.append('g').attr('class', 'labels');
          this.outerBarGroup = this.svg.append('g').attr('class', 'outer-bars');
      }


      // --- Capture previous arc data BEFORE the data join ---
      // This is critical for proper interpolation - we need the old angles
      const previousArcs = new Map<string, { startAngle: number; endAngle: number }>();
      if (this.arcGroup) {
          this.arcGroup.selectAll<SVGPathElement, any>('path').each(function(d) {
              if (d && d.data) {
                  previousArcs.set(d.data, {
                      startAngle: d.startAngle,
                      endAngle: d.endAngle
                  });
              }
          });
      }

      // --- Arc Tween for smooth transitions ---
      // Custom interpolator that morphs between old and new arc angles
      const arcTween = (newData: any) => {
          // Get the previous arc data from our captured map
          const oldArc = previousArcs.get(newData.data);
          const oldData = oldArc ? {
              startAngle: oldArc.startAngle,
              endAngle: oldArc.endAngle
          } : {
              // For new arcs, start collapsed at the new position
              startAngle: newData.startAngle,
              endAngle: newData.startAngle
          };
          
          const interpolate = d3.interpolate(oldData, {
              startAngle: newData.startAngle,
              endAngle: newData.endAngle
          });
          
          return (t: number) => arc({ ...newData, ...interpolate(t) }) || '';
      };

      // --- Update Arcs with Transitions ---
      this.arcSelection = this.arcGroup!
          .selectAll<SVGPathElement, any>('path')
          .data(arcData, (d: any) => d.data);

      // Remove exiting arcs with collapse animation
      this.arcSelection.exit()
          .transition()
          .duration(this.transitionDuration)
          .attrTween('d', function(d: any) {
              // Collapse to center of current position
              const midAngle = (d.startAngle + d.endAngle) / 2;
              const interpolate = d3.interpolate(
                  { startAngle: d.startAngle, endAngle: d.endAngle },
                  { startAngle: midAngle, endAngle: midAngle }
              );
              return (t: number) => arc({ ...d, ...interpolate(t) }) || '';
          })
          .style('opacity', 0)
          .remove();

      // Enter new arcs (start collapsed, expand in)
      const arcEnter = this.arcSelection.enter()
          .append('path')
          .attr('class', 'group-arc')
          .attr('fill', d => validSources.has(d.data) ? this.colorScale(d.data) : 'none')
          .attr('pointer-events', d => validSources.has(d.data) ? 'all' : 'none')
          .attr('id', d => `arc-${d.data}`)
          .style('cursor', d => validSources.has(d.data) ? 'pointer' : 'default')
          .attr('d', d => arc({ ...d, endAngle: d.startAngle }) || '') // Start collapsed
          .style('opacity', 0);

      // Merge enter + update and apply transition
      this.arcSelection = arcEnter.merge(this.arcSelection as any)
          .on('mouseover', (event, d) => {
              if (!validSources.has(d.data)) return; 
              this.highlightArc(d.data);
              const total = Math.round(entityFlows.get(d.data) || 0);
              this.showTooltip(event, `
                <strong>${d.data}</strong><br>
                Total Volume: ${total}
              `);
          })
          .on('mousemove', (event) => this.moveTooltip(event))
          .on('mouseout', () => {
              this.resetHighlight();
              this.hideTooltip();
          })
          .on('click', (event, d) => {
              if (!validSources.has(d.data)) return;
              this.handleArcClick(event, d.data);
          });

      // Animate to new positions - arcs grow/shrink smoothly
      this.arcSelection
          .transition()
          .duration(this.transitionDuration)
          .ease(d3.easeCubicInOut) // Smooth easing for natural feel
          .attrTween('d', (d: any) => arcTween(d))
          .style('opacity', 1)
          .attr('fill', d => validSources.has(d.data) ? this.colorScale(d.data) : 'none')
          .attr('stroke', d => this.selectedArcs.has(d.data) ? '#161616' : null)
          .attr('stroke-width', d => this.selectedArcs.has(d.data) ? 3 : null)


          .attr('stroke', d => this.selectedArcs.has(d.data) ? '#161616' : null)
          .attr('stroke-width', d => this.selectedArcs.has(d.data) ? 3 : null);

          

      // --- Update Labels with Transitions ---
      const labelData = arcData.map((d: any) => ({
          ...d,
          angle: (d.startAngle + d.endAngle) / 2
      }));

      this.textSelection = this.labelGroup!
          .selectAll<SVGTextElement, any>('text')
          .data(labelData, (d: any) => d.data);

      this.textSelection.exit()
          .transition()
          .duration(this.transitionDuration)
          .style('opacity', 0)
          .remove();

      const textEnter = this.textSelection.enter()
          .append('text')
          .attr('dy', '.35em')
          .style('opacity', 0);

      this.textSelection = textEnter.merge(this.textSelection as any)
          .text(d => d.data)
          .style('cursor', 'pointer')
          .on('click', (event, d) => {
              this.handleArcClick(event, d.data);
          })
          .on('mouseover', (event, d) => {
              if (!validSources.has(d.data)) return; 
              this.highlightArc(d.data);
              const total = Math.round(entityFlows.get(d.data) || 0);
              this.showTooltip(event, `
                <strong>${d.data}</strong><br>
                Total Volume: ${total}
              `);
          })
          .on('mousemove', (event) => this.moveTooltip(event))
          .on('mouseout', () => {
              this.resetHighlight();
              this.hideTooltip();
          });

      
      // Assign Selection
      this.textSelection = this.labelGroup!.selectAll<SVGTextElement, any>('text')
          .data(arcData, (d: any) => d.data);
      
      this.textSelection.exit().remove();
      
      const textEnterchord = this.textSelection.enter()
          .append('text')
          .attr('class', 'chord-label')
          .attr('dy', '.35em');
          
      this.textSelection = textEnterchord.merge(this.textSelection as any);

      if (!this.showLabels) {
          // Clear labels if hidden
          this.textSelection.text('').selectAll('*').remove();
          this.labelGroup?.selectAll('.label-path').remove();
      } else {
          this.textSelection
              .style('opacity', 1)
              .each(function(d: any, i: number) {
                   // @ts-ignore
                   const el = d3.select(this);
                   el.text(''); // Clear previous content
                   el.selectAll('*').remove(); // Clear children (textPaths)

                   const arcLen = (d.endAngle - d.startAngle) * ((innerRadius + outerRadius) / 2);
                   const textWidth = d.data.length * 9; // Approx width

                   // Conditional Layout
                   if (arcLen > textWidth + 15) {
                        // --- CURVED INSIDE ---
                        const pathId = `std-chord-label-${i}`;
                        const midR = (innerRadius + outerRadius) / 2;
                        
                        // Path Gen
                        // Top Hemisphere (270 -> 90): Clockwise
                        // Bottom Hemisphere (90 -> 270): Counter-Clockwise
                        const midAngle = (d.startAngle + d.endAngle) / 2;
                        const midAngleDeg = midAngle * 180 / Math.PI;
                        const isBottomHalf = midAngleDeg > 90 && midAngleDeg < 270;

                        const p1 = {
                            x: midR * Math.sin(d.startAngle),
                            y: -midR * Math.cos(d.startAngle)
                        };
                        
                        const p2 = {
                            x: midR * Math.sin(d.endAngle),
                            y: -midR * Math.cos(d.endAngle)
                        };
                        
                        const largeArc = (d.endAngle - d.startAngle) > Math.PI ? 1 : 0;
                        
                        let pathCmd;
                        if (!isBottomHalf) {
                            // Clockwise
                            pathCmd = `M ${p1.x} ${p1.y} A ${midR} ${midR} 0 ${largeArc} 1 ${p2.x} ${p2.y}`;
                        } else {
                            // Counter-Clockwise
                            pathCmd = `M ${p2.x} ${p2.y} A ${midR} ${midR} 0 ${largeArc} 0 ${p1.x} ${p1.y}`;
                        }

                        // Workaround: Append path to the PARENT (labelGroup) if it doesn't exist.
                        const parent = d3.select(this.parentNode as any);
                        let path = parent.select(`#${pathId}`);
                        if (path.empty()) {
                            path = parent.append('path')
                                .attr('id', pathId)
                                .attr('class', 'label-path')
                                .style('fill', 'none')
                                .style('stroke', 'none');
                        }
                        path.attr('d', pathCmd);

                        el.attr('transform', null) // Reset transform
                          .attr('dy', null)
                          .append('textPath')
                          .attr('xlink:href', `#${pathId}`)
                          .attr('startOffset', '50%')
                          .style('text-anchor', 'middle')
                          .style('dominant-baseline', 'middle') 
                          .style('font-weight', 'bold')
                          .style('font-size', '10px')
                          .style('fill', '#000') // Black text inside
                          .style('pointer-events', 'none')
                          .text(d.data);
                   } else {
                        // --- RADIAL OUTSIDE ---
                        const angle = (d.startAngle + d.endAngle) / 2;
                        const rotate = (angle * 180 / Math.PI - 90);
                        const isRight = (angle > Math.PI);
                        
                        el.attr('transform', `
                            rotate(${rotate})
                            translate(${outerRadius + 20}) 
                            ${isRight ? 'rotate(180)' : ''}
                        `)
                        .attr('dy', '.35em')
                        .style('dominant-baseline', null) // Reset baseline
                        .style('text-anchor', isRight ? 'end' : 'start')
                        .text(d.data.length > 18 ? d.data.substring(0, 18) + '...' : d.data)
                        .style('fill', '#333')
                        .style('pointer-events', 'auto')
                        .style('cursor', 'pointer'); // Ensure clickable

                        if (d.data.length > 18) {
                            el.append('title').text(d.data);
                        }
                   }
              })
              .style('font-weight', (d: any) => this.selectedArcs.has(d.data) ? 'bold' : 'bold')
              .style('fill', '#000')
              .style('font-size', (d: any) => this.selectedArcs.has(d.data) ? '12px' : '10px');
      }






      // --- Build Ribbons Data ---
      const padAngle = 0;
      const halfPad = padAngle / 2;

      const currentAngle = new Map<string, number>();
      names.forEach(name => {
          const d = arcMap.get(name);
          currentAngle.set(name, d.startAngle + halfPad);
      });

      const ribbons: any[] = [];
      const ribbonGen = d3.ribbon().radius(innerRadius);

      // Data for Outer Rim Bars (Generated in sync with ribbons)
      const outerBarData: any[] = [];

      dataWithIds.forEach(row => {
          const sourceName = row.starting_point;
          if (!arcMap.has(sourceName)) return;

          const sourceArc = arcMap.get(sourceName);
          const startA = currentAngle.get(sourceName)!;
          const effectiveArcSpan = (sourceArc.endAngle - sourceArc.startAngle) - padAngle;
          const angularWidth = (row.pat_count / entityFlows.get(sourceName)!) * effectiveArcSpan;
          const endA = startA + angularWidth;

          currentAngle.set(sourceName, endA);

          let targets: string[] = [];
          if (row.sub_category_desc) {
              const parts = row.sub_category_desc.split(',').map(s => s.trim());
              targets = parts.filter(t => t !== sourceName);
              if (targets.length === 0) targets.push(sourceName);
          }

          targets.forEach((targetName, i) => {
              const targetArc = arcMap.get(targetName);
              if(!targetArc) return;
              
              const isSelfLoop = targetName === sourceName;
              let targetObj;

              if (isSelfLoop) {
                targetObj = { startAngle: startA, endAngle: endA };
              } else {
                const targetCenter = (targetArc.startAngle + targetArc.endAngle) / 2;
                targetObj = { startAngle: targetCenter, endAngle: targetCenter };
              }
              
              ribbons.push({
                  source: { startAngle: startA, endAngle: endA }, // All share the same source base
                  target: targetObj,
                  sourceName: sourceName,
                  targetName: targetName,
                  data: row,
                  id: `${row.uniqueId}-${targetName}`
              });
          });

          // --- Generate Outer Bar Segments (Split by Target) ---
          // Use the finalized startA and endA for this row.
          // If multiple targets, split the bar angularly to show all colors.
          const totalAngle = endA - startA;
          const segmentAngle = totalAngle / Math.max(targets.length, 1);
          
          targets.forEach((targetName, i) => {
               const segStart = startA + (i * segmentAngle);
               const segEnd = startA + ((i + 1) * segmentAngle);
               
               outerBarData.push({
                   id: `bar-${row.uniqueId}-${i}`, // Unique ID per segment
                   sourceName: sourceName,
                   targetName: targetName, // Color source
                   startAngle: segStart,
                   endAngle: segEnd,
                   value: row.pat_count, 
                   originalRowId: row.uniqueId
               });
          });
      });


    

      // --- Capture previous ribbon data BEFORE the data join ---
      // This is critical for proper interpolation - we need the old source/target angles
      const previousRibbons = new Map<string, { source: any; target: any }>();
      if (this.ribbonGroup) {
          this.ribbonGroup.selectAll<SVGPathElement, any>('path').each(function(d) {
              if (d && d.id) {
                  previousRibbons.set(d.id, {
                      source: { ...d.source },
                      target: { ...d.target }
                  });
              }
          });
      }

      // --- Ribbon Tween for smooth transitions ---
      const ribbonTween = (newData: any) => {
          // Get the previous ribbon data from our captured map
          const oldRibbon = previousRibbons.get(newData.id);
          
          const oldData = oldRibbon ? {
              source: oldRibbon.source,
              target: oldRibbon.target
          } : {
              // For new ribbons, start collapsed at the new position
              source: { startAngle: newData.source.startAngle, endAngle: newData.source.startAngle },
              target: { startAngle: newData.target.startAngle, endAngle: newData.target.startAngle }
          };
          
          const interpolate = d3.interpolate(oldData, {
              source: newData.source,
              target: newData.target
          });
          
          return (t: number) => {
              const interpolated = interpolate(t);
              return (ribbonGen as any)({
                  source: interpolated.source,
                  target: interpolated.target
              }) || '';
          };
      };

      // --- Update Ribbons with Transitions ---
      this.ribbonSelection = this.ribbonGroup!
          .selectAll<SVGPathElement, any>('path')
          .data(ribbons, (d: any) => d.id);

      // Remove exiting ribbons with collapse animation
      this.ribbonSelection.exit()
          .transition()
          .duration(this.transitionDuration)
          .ease(d3.easeCubicInOut)
          .attrTween('d', function(d: any) {
              // Collapse to center point
              const collapsedSource = { 
                  startAngle: (d.source.startAngle + d.source.endAngle) / 2, 
                  endAngle: (d.source.startAngle + d.source.endAngle) / 2 
              };
              const collapsedTarget = { 
                  startAngle: (d.target.startAngle + d.target.endAngle) / 2, 
                  endAngle: (d.target.startAngle + d.target.endAngle) / 2 
              };
              const interpolate = d3.interpolate(
                  { source: d.source, target: d.target },
                  { source: collapsedSource, target: collapsedTarget }
              );
              return (t: number) => {
                  const i = interpolate(t);
                  return (ribbonGen as any)({ source: i.source, target: i.target }) || '';
              };
          })
          .style('opacity', 0)
          .remove();

      // Enter new ribbons (start collapsed)
      const ribbonEnter = this.ribbonSelection.enter()
          .append('path')
          .attr('class', 'ribbon')
          .attr('fill', d => this.colorScale(d.sourceName) as string)
          .attr('data-journey-id', d => d.data.uniqueId)
          .attr('d', d => {
              // Start from collapsed state
              const collapsed = {
                  source: { startAngle: d.source.startAngle, endAngle: d.source.startAngle },
                  target: { startAngle: d.target.startAngle, endAngle: d.target.startAngle }
              };
              return (ribbonGen as any)(collapsed) || '';
          })
          .style('opacity', 0);

      // Merge and apply transition
      this.ribbonSelection = ribbonEnter.merge(this.ribbonSelection as any)
          .on('mouseover', (event, d) => {
              this.highlightRibbons(d.data.uniqueId);
              this.showTooltip(event, `
                  <strong>Journey</strong><br>
                  Start: ${d.sourceName}<br>
                  Path: ${d.data.sub_category_desc}<br>
                  Count: ${d.data.pat_count}
              `);
          })
          .on('mousemove', (event) => this.moveTooltip(event))
          .on('mouseout', () => {
              this.resetHighlight();
              this.hideTooltip();
          })
          .on('click', (event, d) => {
             // Toggle selection using pat_seq_sub_cat_key
             const key = d.data.pat_seq_sub_cat_key;
             if (this.selectedRibbons.has(key)) {
                 this.selectedRibbons.delete(key);
             } else {
                 this.selectedRibbons.add(key);
             }
             this.drawChart(); // Redraw to update styles
             event.stopPropagation();
          });

      // Animate ribbons to new positions - smooth morphing
      this.ribbonSelection
          .transition()
          .duration(this.transitionDuration)
          .ease(d3.easeCubicInOut) // Smooth easing for natural feel
          .attrTween('d', (d: any) => ribbonTween(d))
          .style('opacity', this.ribbonOpacity)
          .attr('fill', d => this.colorScale(d.sourceName) as string)
          .attr('stroke', d => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? '#000000' : null)
          .attr('stroke-width', d => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? 3 : 0)
          .style('opacity', d => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? selectedOpacity : this.ribbonOpacity)
          .attr('stroke-opacity', d => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? 1 : 0);



      // // Scale for dynamic bar height (Increased range)
      // const maxRibbonValue = d3.max(ribbons, (r: any) => r.data.pat_count) || 1;
      // const barHeightScale = d3.scaleLinear()
      //     .domain([0, maxRibbonValue])
      //     .range([10, 60]); // Min 10px, Max 60px thickness (Taller)

      // // Join data (outerBarData is now pre-calculated)
      // const barCSelection = this.outerBarGroup!.selectAll<SVGPathElement, any>('path')
      //     .data(outerBarData, (d:any) => d.id);

      // barCSelection.exit().remove();

      // const barEnter = barCSelection.enter()
      //     .append('path')
      //     .attr('class', 'outer-segment')
      //     .style('opacity', 0);

      // // Arc generator for segments (Dynamic Height)
      // const barArc = d3.arc<any>()
      //     .innerRadius(outerRadius + 2) // Reduced gap (was +10)
      //     .outerRadius((d: any) => outerRadius + 2 + barHeightScale(d.value)) // Dynamic height
      //     .startAngle(d => d.startAngle)
      //     .endAngle(d => d.endAngle);

      // barEnter.merge(barCSelection as any)
      //     .transition()
      //     .duration(this.transitionDuration)
      //     .attrTween('d', function(d: any) {
      //        return () => barArc(d) || ''; 
      //     })
      //     .attr('fill', d => this.colorScale(d.targetName) as string) // Color by TARGET
      //     .style('opacity', 1);
      
      // // Tooltip for segments
      // barEnter.merge(barCSelection as any)
      //     .on('mouseover', (event, d) => {
      //         this.showTooltip(event, `
      //             <strong>${d.sourceName} &rarr; ${d.targetName}</strong><br>
      //             Volume: ${d.value}
      //         `);
              
      //         // Highlight the ribbon associated with this segment
      //         // We can find it by IDs or shared data
      //         // The ribbon creation loop made IDs like `${row.uniqueId}-${targetName}`
      //         // Optimization: We could store the ribbon ID in bar data.
      //         // Let's rely on standard highlight logic if possible, or trigger ribbon highlight.
      //         // highlightRibbons expects a journey ID.
      //        this.hideTooltip(); 
      //     });
      this.stop(10).then(() => this.isLoading = false);
  }

  // --- Interaction Methods ---

  highlightRibbons(id: string) {
      if (!this.ribbonSelection) return;
      
      // GUARD: If interaction tooltip is active with selections, DO NOT override highlight
      if (this.interactionTooltipData.visible && this.interactionTooltipData.targets.some(t => t.selected)) return;
      
      const selectedOpacity = 0.9;
      
      // 1. Highlight Ribbons
      // If a ribbon is selected, keep it visible (selectedOpacity). Otherwise dim it (0.1).
      this.ribbonSelection
          .style('opacity', (d: any) => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? selectedOpacity : 0.1)
          // Keep existing selection stroke if present
          .attr('stroke', (d: any) => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? '#000000' : null)
          .attr('stroke-width', (d: any) => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? 3 : null);

      const activeRibbon = this.ribbonSelection.filter(`[data-journey-id="${id}"]`)
          .style('opacity', 1)
          .attr('stroke', '#161616')
          .attr('stroke-width', (d: any) => {
             // If this specific hovered ribbon is ALSO selected, keep the thick border
             if (this.selectedRibbons.has(d.data.pat_seq_sub_cat_key)) return 3;
             return 1;
          })
          .raise();

      if (!activeRibbon.empty()) {
          const datum = activeRibbon.datum() as any;
          
          // Collect all associated entities from the journey data
          const associatedEntities = new Set<string>();
          associatedEntities.add(datum.data.starting_point);
          if (datum.data.sub_category_desc) {
              datum.data.sub_category_desc.split(',').forEach((s: string) => associatedEntities.add(s.trim()));
          }

          // 2. Highlight Arcs
          if (this.arcSelection) {
              this.arcSelection.style('opacity', 0.1);
              this.arcSelection.filter((d: any) => associatedEntities.has(d.data))
                  .style('opacity', 1);
          }

          // 3. Highlight Text
          if (this.textSelection) {
              this.textSelection.style('opacity', 0.1);
              this.textSelection.filter((d: any) => associatedEntities.has(d.data))
                  .style('opacity', 1);
          }
      }
  }

  highlightArc(sourceName: string) {
      if (!this.ribbonSelection) return;
      
      // GUARD: If interaction tooltip is active with selections, ignore hover highlight
      if (this.interactionTooltipData.visible && this.interactionTooltipData.targets.some(t => t.selected)) return;

      const selectedOpacity = 0.9;

      // 1. Highlight Ribbons
      // Standard dims others, but keep selected ones visible
      this.ribbonSelection
          .style('opacity', (d: any) => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? selectedOpacity : 0.1)
           // Ensure selection stroke persists
          .attr('stroke', (d: any) => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? '#000000' : null)
          .attr('stroke-width', (d: any) => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? 3 : null);


      const relatedRibbons = this.ribbonSelection.filter((d: any) => d.sourceName === sourceName)
          .style('opacity', 1)
          .attr('stroke', (d: any) => {
              // If selected, keep it black. Otherwise color it (or black/dark for contrast).
              if (this.selectedRibbons.has(d.data.pat_seq_sub_cat_key)) return '#000000';
              // Default hover behavior for arc connections usually colors them distinctively or keeps them as is. 
              // The original code used this.colorScale(sourceName).
              return this.colorScale(sourceName) as string;
          })
          .attr('stroke-width', (d: any) => {
               // If selected, keep it thick.
               if (this.selectedRibbons.has(d.data.pat_seq_sub_cat_key)) return 3;
               return 1;
          })
          .raise();

      const connectedEntities = new Set<string>();
      connectedEntities.add(sourceName);
      relatedRibbons.each((d: any) => connectedEntities.add(d.targetName));

      // 2. Highlight Arcs
      if (this.arcSelection) {
          this.arcSelection.style('opacity', 0.1);
          this.arcSelection.filter((d: any) => connectedEntities.has(d.data))
              .style('opacity', 1);
      }

      // 3. Highlight Text
      if (this.textSelection) {
          this.textSelection.style('opacity', 0.1);
          this.textSelection.filter((d: any) => connectedEntities.has(d.data))
              .style('opacity', 1);
      }
  }

  resetHighlight() {
      // GUARD: If interaction tooltip is active, DO NOT reset. The tooltip manages state.
      if (this.interactionTooltipData.visible) return;

      const selectedOpacity = 0.9;
      if (this.ribbonSelection) {
        this.ribbonSelection
            .style('opacity', (d: any) => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? selectedOpacity : this.ribbonOpacity)
            .attr('stroke', (d: any) => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? '#000000' : null)
            .attr('stroke-width', (d: any) => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? 3 : 0);
      }
      
      if (this.textSelection) {
          this.textSelection.style('opacity', 1);
      }

      if (this.arcSelection) {
          this.arcSelection.style('opacity', 1);
      }
      
      // Reset Outer Bars if dimmed? (Currently we don't dim them explicitly, but if we did...)
  }

  public toggleLabels(): void {
    this.showLabels = !this.showLabels;
    // Dispatch to the correct render method based on active chart type
    if (this.edge_bundling) {
        this.createBundleChart();
    } else {
        this.drawChart(); 
    }
  }

  public get hasSelections(): boolean {
      return this.selectedArcs.size > 0 || this.selectedRibbons.size > 0 || this.selectedBars.size > 0;
  }

  public clearSelections(): void {
      this.selectedArcs.clear();
      this.selectedRibbons.clear();
      this.selectedBars.clear();
      this.selectedSourceFilter = null;
      this.isFocused = false;

      // Reset any D3 selections if needed (like opacity) - mostly handled by redraw
      if (this.edge_bundling) {
          this.createBundleChart();
      } else {
          this.drawChart();
      }
  }

  // --- Tooltip Utils ---
  
  private createTooltip(): void {
      // Scope to this component instance to avoid conflicts
      if (this.fs?.nativeElement) {
          this.tooltip = d3.select(this.fs.nativeElement).select('.chord-tooltip');
      } else {
          // Fallback
          this.tooltip = d3.select('.chord-tooltip');
      }

      if (this.tooltip.empty()) {
          this.tooltip = d3.select('body').append('div')
              .attr('class', 'chord-tooltip');
      }
      
      this.tooltip
          .style('opacity', 0);
  }

  private showTooltip(event: any, content: string): void {
      if (!this.tooltip || this.tooltip.empty()) this.createTooltip();
      
      let x = event.pageX;
      let y = event.pageY;
      
      // If tooltip is inside our component (which has position:relative), calculate relative coords
      if (this.fs?.nativeElement && this.tooltip.node().parentNode === this.fs.nativeElement) {
          const coords = d3.pointer(event, this.fs.nativeElement);
          x = coords[0];
          y = coords[1];
      }

      this.tooltip.transition().duration(200).style('opacity', 1);
      
      this.tooltip.html(content);
      
      // Determine positioning with boundary checks
      const containerWidth = this.fs?.nativeElement?.offsetWidth || window.innerWidth;
      const tooltipNode = this.tooltip.node();
      const tooltipRect = tooltipNode.getBoundingClientRect();
      const tooltipWidth = tooltipRect.width || 200;
      
      const isLeftHalf = x < containerWidth / 2;
      let leftPos = x + 15;
      let topPos = y - 28; // Default top position

      if (isLeftHalf) {
          // Prefer LEFT side to avoid expanding bars
          if (x - tooltipWidth - 15 > 0) {
              leftPos = x - tooltipWidth - 15;
          } else {
              // No space on left, force to right
              leftPos = x + 15;
              // If forced right (inward), shift DOWN to avoid covering the bar
              topPos = y + 40;
          }
      } else {
          // Prefer RIGHT side
          if (x + tooltipWidth + 15 < containerWidth) {
              leftPos = x + 15;
          } else {
              // No space on right, force to left
              leftPos = x - tooltipWidth - 15;
              // If forced left (inward), shift DOWN to avoid covering the bar
              topPos = y + 40;
          }
      }
      
      this.tooltip
          .style('left', leftPos + 'px')
          .style('top', topPos + 'px');
  }

  private moveTooltip(event: any): void {
      if (!this.tooltip) return;
      
      let x = event.pageX;
      let y = event.pageY;

      if (this.fs?.nativeElement && this.tooltip.node().parentNode === this.fs.nativeElement) {
          const coords = d3.pointer(event, this.fs.nativeElement);
          x = coords[0];
          y = coords[1];
      }

      const containerWidth = this.fs?.nativeElement?.offsetWidth || window.innerWidth;
      const tooltipNode = this.tooltip.node();
      const tooltipRect = tooltipNode.getBoundingClientRect();
      const tooltipWidth = tooltipRect.width || 200;
      
      const isLeftHalf = x < containerWidth / 2;
      let leftPos = x + 15; 
      let topPos = y - 28;

      if (isLeftHalf) {
          if (x - tooltipWidth - 15 > 0) {
              leftPos = x - tooltipWidth - 15;
          } else {
              leftPos = x + 15;
              topPos = y + 40;
          }
      } else {
          if (x + tooltipWidth + 15 < containerWidth) {
              leftPos = x + 15;
          } else {
             leftPos = x - tooltipWidth - 15;
             topPos = y + 40;
          }
      }

      this.tooltip
          .style('left', leftPos + 'px')
          .style('top', topPos + 'px');
  }

  private hideTooltip(): void {
      if (this.tooltip) this.tooltip.transition().duration(500).style('opacity', 0);
  }

  // --- Helpers for Consolidation ---

  private get isInteractionLocked(): boolean {
      return this.interactionTooltipData.visible && this.interactionTooltipData.targets.some(t => t.selected);
  }

  private prepareChartContainer(): { element: any, width: number, height: number, radius: number } {
        if (!this.ChordChartContainer) {
            return { element: null, width: 800, height: 800, radius: 400 };
        }
        const element = this.ChordChartContainer.nativeElement;
        d3.select(element).selectAll('*').remove();

        // Use same dims or responsive? 
        const width = 800; // Fixed for now or use this.initialChartWidth
        const height = 800;
        const radius = width / 2;

        this.svg = d3.select(element)
            .append('svg')
            .attr('viewBox', [-width / 2, -height / 2, width, height] as any)
            .style('font', '10px sans-serif')
            .style('width', '100%')
            .style('height', 'auto');
            
        return { element, width, height, radius };
  }

  private processBundleData(): FlowHierarchyNode {
        const groupMap = new Map<string, FlowHierarchyNode>();
        const targetSet = new Set<string>();

        // Collecting data
        (this.data || []).forEach((d: any, i: number) => {
            const start = d.starting_point ? d.starting_point.trim() : '';
            if (!start) return;

            // Ensure Group Exists
            if (!groupMap.has(start)) {
                groupMap.set(start, {
                    name: start,
                    children: [],
                    group: start
                });
            }

            // Create Leaf Node (Journey)
            const targets: string[] = [];
            if (d.sub_category_desc) {
                const parts = d.sub_category_desc.split(',').map((s: string) => s.trim());
                parts.forEach((t: string) => {
                    // Allow self-reference ONLY if it's the only target (explicit loop)
                    // Otherwise hide implicit start->start connections to reduce clutter
                    if (t === start && parts.length > 1) return;
                    
                    targets.push(t);
                    targetSet.add(t);
                });
            }

            const leaf: FlowHierarchyNode = {
                name: `journey-${i}`, // Internal ID
                group: start,
                volume: d.pat_count,
                targets: targets,
                key: `journey-${i}`,
                pat_seq_sub_cat_key: d.pat_seq_sub_cat_key,
                label: d.sub_category_desc,
                starting_point: start, // Compatibility field
                sub_category_desc: d.sub_category_desc // Compatibility field
            };

            groupMap.get(start)!.children!.push(leaf);
        });

        // Handle Pure Targets
        targetSet.forEach(t => {
            if (!groupMap.has(t)) {
                groupMap.set(t, {
                    name: t,
                    group: t,
                    children: [{
                        name: `${t}-anchor`,
                        group: t,
                        volume: 0,
                        targets: [],
                        key: `${t}-anchor`
                    }]
                });
            }
        });

        const groups = Array.from(groupMap.values()).sort((a, b) => d3.ascending(a.name, b.name));

        return {
            name: "root",
            children: groups
        };
  }

  createBundleChart(): void {
        const { element, radius } = this.prepareChartContainer();
        if (!element) return;

        // 1. Process Data & Build Hierarchical Structure
        const hierarchyData = this.processBundleData();
        
        // --- Layout Configuration ---
        // User requested "Everything needs to be brought in a little" and to fix label overflow.
        // We reduce the chart size to make room for labels and shrink the center hole.
        const maxBarHeight = 120;  // Increased to 120 for taller bars
        // Increase leafRadius to push bars to the rim. 
        // We reserve space for the gap (5px) + arc (25px) + labels (~20-40px).
        // Total reserve = ~60px per side.
        const leafRadius = radius - 140; 
        const gap = 5; // Gap between bars and outer arcs
        const labelGap = -5; 
        // Labels will now be outside the group arcs
        const labelRadius = leafRadius + gap + labelGap;

        // 2. Compute Layout
        const root = d3.hierarchy<FlowHierarchyNode>(hierarchyData)
            .sort((a, b) => {
                if (a.depth === 1 && b.depth === 1) {
                    return d3.ascending(a.data.name, b.data.name);
                }
                return d3.descending(a.data.volume || 0, b.data.volume || 0);
            });

        const cluster = d3.cluster<FlowHierarchyNode>()
            .size([360, leafRadius]); // Use defined leafRadius

        cluster(root);

        // 3. Link Generation
        const groupLeaves = new Map<string, d3.HierarchyPointNode<FlowHierarchyNode>[]>();
        
        root.leaves().forEach(node => {
            const g = node.data.group!;
            if (!groupLeaves.has(g)) groupLeaves.set(g, []);
            groupLeaves.get(g)!.push(node as d3.HierarchyPointNode<FlowHierarchyNode>);
        });

        const links: any[] = [];
        const leaves = root.leaves() as d3.HierarchyPointNode<FlowHierarchyNode>[];

        leaves.forEach(sourceLeaf => {
            const d = sourceLeaf.data;
            if (!d.targets || d.targets.length === 0) return;

            d.targets.forEach(targetName => {
                const potentialTargets = groupLeaves.get(targetName);
                if (potentialTargets && potentialTargets.length > 0) {
                    const midIndex = Math.floor(potentialTargets.length / 2);
                    const targetNode = potentialTargets[midIndex];

                    const path = sourceLeaf.path(targetNode);
                    
                    links.push({
                        source: sourceLeaf,
                        target: targetNode,
                        path: path,
                        value: d.volume,
                        targetsAll: d.targets,
                        targetsAll: d.targets,
                        groupName: d.group,
                        sourceName: d.group, // Compatibility field for updateDetailedHighlight
                        data: d // Include full node data (has pat_seq_sub_cat_key)
                    });
                }
            });
        });


        
         // Set up scales
        // Define color scale based on group names
        const allGroups = (hierarchyData.children || []).map(g => g.name);
        // Use a persistent color scale if possible, or new one
        if (!this.masterColorScale) {
             this.masterColorScale = d3.scaleOrdinal(d3.schemeCategory10).domain(allGroups);
        }
        this.colorScale = this.masterColorScale;

        const maxVol = d3.max(leaves, d => d.data.volume) || 1000;
        const barHeightScale = d3.scaleLinear()
            .domain([0, maxVol])
            .range([10, maxBarHeight]);

        // 5. Draw Links
        const line = d3.lineRadial<d3.HierarchyPointNode<FlowHierarchyNode>>()
            .curve(d3.curveBundle.beta(0.85))
            .radius((d: any) => {
                // If leaf node, shorten the link to connect to the INWARD pointing bar tip
                // The bar extends from d.y (leafRadius) inwards by barHeight
                // So the link should end at d.y - barHeight
                if (!d.children && d.data.volume) {
                     const h = barHeightScale(d.data.volume) || 0;
                     return d.y - h;
                }
                return d.y;
            })
            .angle((d: any) => d.x / 180 * Math.PI);

        const linkGroup = this.svg.append('g')
            .attr('class', 'links')
            .selectAll('path')
            .data(links)
            .join('path')
            .attr('class', 'bundle-link')
            .attr('d', d => line(d.path))
            .style('fill', 'none');
        
        this.ribbonSelection = linkGroup; // Assign to class property for global updates

        linkGroup
            // @ts-ignore
            .style('stroke', d => {
                 if (this.selectedRibbons.has(d.data.pat_seq_sub_cat_key)) return '#000000';
                 return this.colorScale(d.source.data.group);
            })
            .style('stroke-opacity', d => {
                if (this.selectedRibbons.has(d.data.pat_seq_sub_cat_key)) return 0.9;
                return 0.5;
            })
            .style('stroke-width', d => {
                if (this.selectedRibbons.has(d.data.pat_seq_sub_cat_key)) return 3;
                return 1;
            })
            .on('click', (event, d) => {
                 // Toggle selection
                 const key = d.data.pat_seq_sub_cat_key;
                 if (key) {
                     if (this.selectedRibbons.has(key)) {
                         this.selectedRibbons.delete(key);
                     } else {
                         this.selectedRibbons.add(key);
                     }
                     // Redraw or update styles? Ideally update styles to avoid full re-render
                     // For now, re-render to be safe or update selection styles manually
                     this.createBundleChart(); 
                 }
                 event.stopPropagation();
            })
            .style('stroke-width', d => {
                if (this.selectedRibbons.has(d.data.pat_seq_sub_cat_key)) return 3;
                return 1;
            })
            .on('click', (event, d) => {
                 // Toggle selection
                 const key = d.data.pat_seq_sub_cat_key;
                 if (key) {
                     if (this.selectedRibbons.has(key)) {
                         this.selectedRibbons.delete(key);
                     } else {
                         this.selectedRibbons.add(key);
                     }
                     // Redraw or update styles? Ideally update styles to avoid full re-render
                     // For now, re-render to be safe or update selection styles manually
                     this.createBundleChart(); 
                 }
                 event.stopPropagation();
            });

        // 6. Draw Nodes (Radial Bars)
        const nodeGroup = this.svg.append('g')
            .attr('class', 'nodes')
            .selectAll('g')
            .data(leaves)
            .join('g')
            .attr('transform', (d: any) => `rotate(${d.x - 90}) translate(${d.y},0)`);

        const cScale = this.colorScale;
        
        nodeGroup.each((d: any, i, nodes) => {
            const g = d3.select(nodes[i]);
            const targets = d.data.targets || [];
            const vol = d.data.volume || 1;
            const totalHeight = barHeightScale(vol);

            if (targets.length === 0) {
                 g.append('rect')
                    .attr('x', 0)
                    .attr('y', -2)
                    .attr('width', 2)
                    .attr('height', 4)
                    .attr('fill', '#ccc');
                 return;
            }
            
            const segmentHeight = totalHeight / targets.length;
            const barWidth = 12; 

            // Draw INWARD pointing bars (Growing from 0 to -totalHeight)
            targets.forEach((targetName: string, idx: number) => {
                // Stack starting from the rim (0) and going inwards
                // x = 0 corresponds to leafRadius.
                // We want to draw rects in the negative x direction.
                // idx=0: x = -segmentHeight (closest to rim) ... NO
                // We want visual stacking. 
                // Let's place them such that the stack ends at 0.
                // x range: [-totalHeight, 0]
                // slice 0: [-segmentHeight, 0]? OR [-totalHeight, -totalHeight + seg]?
                // Usually order matters. Let's stack them simply.
                // x = - (idx + 1) * segmentHeight
                
                g.append('rect')
                    .attr('x', -((idx + 1) * segmentHeight)) // Stack inward
                    .attr('y', -barWidth / 2)
                    .attr('width', segmentHeight)
                    .attr('height', barWidth)
                    // @ts-ignore
                    .attr('fill', cScale(targetName));
            });
                        // Invisible hit area covering the whole bar stack
             g.append('rect')
              .attr('x', -totalHeight) // Starts at inner tip
              .attr('y', -barWidth / 2)
              .attr('width', totalHeight)
             .attr('height', barWidth)
             .style('opacity', 0) 
             .on('mouseover', (event) => {
                this.highlightLeaf(d, linkGroup, nodeGroup, textGroup, arcGroup);
                
                // Scale up the bar (grow inward)
                // Dynamic scale to ensure at least 20px growth for small bars
                const growthPx = 20;
                const scaleFactor = (totalHeight + growthPx) / Math.max(totalHeight, 1);
                
                g.transition()
                    .duration(200)
                    .attr('transform', `rotate(${d.x - 90}) translate(${d.y},0) scale(${scaleFactor}, 1)`);

                this.showTooltip(event, `
                  <strong>Origin: ${d.data.group}</strong><br>
                  Path: ${d.data.label || d.data.group}<br>
                  Volume: ${d.data.volume}<br>
                  Targets: ${targets.join(', ')}
                `);
             })
             .on('mouseout', () => {
                this.resetHighlightBundle(linkGroup, nodeGroup, textGroup, arcGroup);
                
                // Reset scale
                g.transition()
                    .duration(200)
                    .attr('transform', `rotate(${d.x - 90}) translate(${d.y},0) scale(1, 1)`);

                this.hideTooltip();
             })
             .on('click', (event) => {
                 // Toggle selection for the RIBBON associated with this bar
                 const key = d.data.pat_seq_sub_cat_key;
                 if (key) {
                     if (this.selectedRibbons.has(key)) {
                         this.selectedRibbons.delete(key);
                     } else {
                         this.selectedRibbons.add(key);
                     }
                     this.createBundleChart(); 
                 }
                 event.stopPropagation();
             });
        });

        // 7. Draw Group Labels and Inner Arcs
        // 7. Draw Group Labels and Inner Arcs
        const arcGroup = this.svg.append('g').attr('class', 'group-arcs');
        const textGroup = this.svg.append('g').attr('class', 'labels');

        // Assign to class key selections (we select children because logic filters them)
        // Wait, updateDetailedHighlight logic typically runs .style on the selection directly.
        // For bundle, we assigned data to children.
        // TextGroup is a G. 
        // We should assign the text SELECTION.
        // But the text elements aren't created yet inside the loop.
        // We can't assign them here.
        // We must select them AFTER the loop.
        
        const groupNodes = root.children || [];
        
        groupNodes.forEach((g: any, i: number) => {
             const leaves = g.leaves();
             if (leaves.length === 0) return;

             // Leaves are at leafRadius.
             // We want Arcs to be OUTSIDE leafRadius + gap.
             
             // Dynamic Label Radius? Labels are outside the Arcs.
             // The Arc Thickness is constant (25px).
             // leafRadius -> Gap (5) -> Arc (25) -> Label
             const arcInner = leafRadius + gap;
             const arcOuter = arcInner + 25;
             const dynamicLabelRadius = arcOuter + labelGap;
             
             const angles = leaves.map((l: any) => l.x as number);
             const minA = (d3.min(angles) || 0) as number;
             const maxA = (d3.max(angles) || 0) as number;
             const midA = (minA + maxA) / 2;

             // Draw Inner Group Arc
             // Add small padding for visual width
             const anglePadding = 1.5; // degrees
             const startAngle = (minA - anglePadding) * (Math.PI / 180);
             const endAngle = (maxA + anglePadding) * (Math.PI / 180);
             
             // Thicker Arc: 25px
             const innerR = arcInner;
             const outerR = arcOuter;

             const arcGen = d3.arc()
                .innerRadius(innerR)
                .outerRadius(outerR)
                .startAngle(startAngle)
                .endAngle(endAngle);

             arcGroup.append('path')
                .datum(g) 
                .attr('d', arcGen as any)
                .style('fill', this.colorScale(g.data.name))
                .style('opacity', 1)
                .on('click', (event) => {
                     this.handleArcClick(event, g.data.name);
                 })
                 .on('mouseover', (event) => {
                     this.highlightGroup(g, linkGroup, nodeGroup, textGroup, arcGroup);
                     // Calculate total volume for the group
                     const totalVolume = d3.sum(g.leaves(), (node: any) => node.data.volume || 0);
                     this.showTooltip(event, `
                        <strong>${g.data.name}</strong><br>
                        Total Volume: ${totalVolume}
                     `);
                 })
                 .on('mouseout', () => {
                     this.resetHighlightBundle(linkGroup, nodeGroup, textGroup, arcGroup);
                     this.hideTooltip();
                 });

             // --- Label Logic ---
             if (this.showLabels) {
                 // Calculate Arc Length (approximate using middle radius)
                 const midR = (innerR + outerR) / 2;
                 const arcLength = (endAngle - startAngle) * midR;
                 
                 // Truncation Logic
                 const MAX_LABEL_LENGTH = 12;
                 const fullTextStr = g.data.name;
                 const isTruncated = fullTextStr.length > MAX_LABEL_LENGTH;
                 const displayText = isTruncated ? fullTextStr.substring(0, MAX_LABEL_LENGTH) + '...' : fullTextStr;

                 // Approx text width: 7px per char for 10px bold font (conservative)
                 const approxTextWidth = displayText.length * 8; 

                 // Check if it fits (with some padding)
                 if (arcLength > approxTextWidth + 20) {
                     // --- CURVED LABEL INSIDE ARC ---
                     
                     // Create a unique ID for the path
                     const pathId = `group-arc-path-${i}`;
                     
                     // Define a path for text to follow.
                     // Correct logic for "Right Side Up":
                     // Top Hemisphere (270 -> 90 / 9 o'clock to 3 o'clock): Clockwise (Bottom points IN)
                     // Bottom Hemisphere (90 -> 270 / 3 o'clock to 9 o'clock): Counter-Clockwise (Bottom points OUT)
                     const midAngleDeg = midA;
                     const isBottomHalf = midAngleDeg > 90 && midAngleDeg < 270;
                     
                     const textRadius = (innerR + outerR) / 2;
                     
                     // Helper to get params
                     const getCoords = (a: number) => {
                         return {
                             x: textRadius * Math.sin(a),
                             y: -textRadius * Math.cos(a)
                         };
                     };

                     let p1, p2, sweepFlag;
                     // Note: d3 angles are in Radians here
                     if (!isBottomHalf) {
                         // Top Half: Clockwise
                         p1 = getCoords(startAngle);
                         p2 = getCoords(endAngle);
                         sweepFlag = 1; // Clockwise
                     } else {
                         // Bottom Half: Counter-Clockwise
                         // Traverse from End to Start
                         p1 = getCoords(endAngle);
                         p2 = getCoords(startAngle);
                         sweepFlag = 0; // Counter-Clockwise
                     }
                     
                     const largeArcFlag = (endAngle - startAngle) > Math.PI ? 1 : 0;
                     
                     const pathCmd = `M ${p1.x} ${p1.y} A ${textRadius} ${textRadius} 0 ${largeArcFlag} ${sweepFlag} ${p2.x} ${p2.y}`;

                     // Path for text
                     textGroup.append('path')
                        .attr('id', pathId)
                        .attr('d', pathCmd)
                        .style('fill', 'none')
                        .style('stroke', 'none');

                     const textEl = textGroup.append('text')
                         .datum(g)
                         .append('textPath')
                         .attr('startOffset', '50%')
                         .style('text-anchor', 'middle')
                         .style('dominant-baseline', 'middle') 
                         .attr('xlink:href', `#${pathId}`)
                         .style('font-weight', 'bold')
                         .style('font-size', '10px')
                         .style('fill', '#000') // Black Text
                         .style('pointer-events', 'none') 
                         .text(displayText);
                         
                     // Add tooltip for full name
                     if (isTruncated) {
                         textEl.append('title').text(fullTextStr);
                     }
                         
                 } else {
                     // --- FALLBACK: RADIAL LABEL OUTSIDE ---
                     const angle = midA;
                     const rotate = angle - 90;
                     const adjust = angle < 180 ? 0 : 180;
                     const align = angle < 180 ? 'start' : 'end';

                     textGroup.append('text')
                         .datum(g)
                         .attr('transform', `
                            rotate(${rotate}) 
                            translate(${dynamicLabelRadius}) 
                            rotate(${adjust})
                         `)
                         .attr('dy', '0.31em')
                         .attr('x', angle < 180 ? 10 : -10)
                         .style('text-anchor', align)
                         .style('font-weight', 'bold')
                         .style('font-size', '10px')
                         .style('fill', '#333')
                         .style('cursor', 'pointer')
                         .text(displayText)
                         .on('click', (event) => {
                             this.handleArcClick(event, g.data.name);
                         })
                         .on('mouseover', () => this.highlightGroup(g, linkGroup, nodeGroup, textGroup, arcGroup))
                         .on('mouseout', () => this.resetHighlightBundle(linkGroup, nodeGroup, textGroup, arcGroup))
                         .append('title').text(fullTextStr); // Always add title for radial labels or just check isTruncated? Best to always add or just matches.
                 }
             }
         });
        
        // Assign Selections (Select all created children)
        this.textSelection = textGroup.selectAll('text');
        this.arcSelection = arcGroup.selectAll('path');
        // Assign Node selection for detailed highlighting
        this.nodeSelection = nodeGroup;

        // 8. Attach Ribbon Interactions (Late binding to access all groups)
        linkGroup
            .on('mouseover', (event, d: any) => {
                 this.highlightLeaf(d.source, linkGroup, nodeGroup, textGroup, arcGroup);
                 
                 // Show Specific Tooltip
                 const targets = d.source.data.targets || [];
                 this.showTooltip(event, `
                   <strong>Origin: ${d.source.data.group}</strong><br>
                   Path: ${d.source.data.label || d.source.data.group}<br>
                   Volume: ${d.source.data.volume}<br>
                   Targets: ${targets.join(', ')}
                 `);
                
                // Emphasize this specific ribbon slightly more? 
                // highlightLeaf sets all source ribbons to opacity 1. 
                // We can raise this one specifically.
                d3.select(event.currentTarget).raise();
            })
            .on('mouseout', () => {
                 this.resetHighlightBundle(linkGroup, nodeGroup, textGroup, arcGroup);
                 this.hideTooltip();
            });
      this.stop(10).then(() => this.isLoading = false);
  }

  highlightGroup(g: any, linkGroup: any, nodeGroup: any, textGroup: any, arcGroup: any) {
      if (this.isInteractionLocked) return;
      
      // 1. Identify Connected Targets
      const connectedGroups = new Set<string>();
      connectedGroups.add(g.data.name); // Add Source
      
      // Find all links originating from this group
      const associatedLinks = linkGroup.filter((l: any) => l.source.data.group === g.data.name);
      associatedLinks.each((l: any) => connectedGroups.add(l.target.data.group));

      // 2. Dim Everything
      linkGroup.style('opacity', 0.1);
      nodeGroup.style('opacity', 0.1); // Dim bars more to emphasize flow
      textGroup.selectAll('text').style('opacity', 0.1);
      arcGroup.selectAll('path').style('opacity', 0.1);
      
      // 3. Highlight Associated Links
      associatedLinks
         .style('opacity', 1)
         .style('stroke', '#000') 
         .raise();
         
      // 4. Highlight Associated Labels and Arcs (Source + Targets)
      textGroup.selectAll('text').filter((t: any) => connectedGroups.has(t.data.name)).style('opacity', 1).style('font-weight', 'bold');
      arcGroup.selectAll('path').filter((t: any) => connectedGroups.has(t.data.name)).style('opacity', 1);
      
      // 5. Highlight Associated Bars (Optional but good)
      nodeGroup.filter((n: any) => connectedGroups.has(n.data.group)).style('opacity', 1);
  }

  highlightLeaf(leaf: any, links: any, nodes: any, texts: any, arcs: any) {
        // GUARD
        if (this.isInteractionLocked) return;

        // Dim Elements
        links.style('opacity', (l: any) => this.selectedRibbons.has(l.data.pat_seq_sub_cat_key) ? 0.9 : 0.1);
        nodes.style('opacity', 0.1);
        texts.selectAll('text').style('opacity', 0.1);
        arcs.selectAll('path').style('opacity', 0.1);

        // Identify Connected Groups for this leaf
        const connectedGroups = new Set<string>();
        connectedGroups.add(leaf.data.group); // Source
        const targets = leaf.data.targets || [];
        targets.forEach((t: string) => connectedGroups.add(t));

        // Highlight this node (bar)
        nodes.filter((n: any) => n === leaf).style('opacity', 1);
        
        // Highlight outgoing links
        links.filter((l: any) => l.source === leaf)
            .style('opacity', 1)
            .style('stroke-width', 2.5)
            .style('stroke', '#000') 
            .raise();
            
        // Highlight Labels and Arcs
        texts.selectAll('text').filter((t: any) => connectedGroups.has(t.data.name)).style('opacity', 1);
        arcs.selectAll('path').filter((t: any) => connectedGroups.has(t.data.name)).style('opacity', 1);
  }

  resetHighlightBundle(links: any, nodes: any, texts: any, arcs: any) {
        // GUARD
        if (this.interactionTooltipData.visible) return; // Keep locked view

        if (!this.colorScale) return;
        
        // Reset Opacity
        nodes.style('opacity', 1);
        texts.selectAll('text').style('opacity', 1).style('font-weight', 'bold'); // Reset font weight too if changed
        arcs.selectAll('path').style('opacity', 1);
        
        // @ts-ignore
        links
            .style('opacity', (d: any) => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? 0.9 : 1)
            // @ts-ignore
            .style('stroke', (d: any) => {
                 if (this.selectedRibbons.has(d.data.pat_seq_sub_cat_key)) return '#000000';
                 return this.colorScale(d.source.data.group);
            })
            .style('stroke-width', (d: any) => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? 3 : 1)
            .style('stroke-opacity', (d: any) => this.selectedRibbons.has(d.data.pat_seq_sub_cat_key) ? 0.9 : 0.5);

  }

  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:mozfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])
  onFullscreenChange(event: any) {
    const fsElement = this.fs?.nativeElement;
    const isFs = document.fullscreenElement === fsElement; 
    
    // Update State
    this.isFullscreen = isFs;
    this.isActive = isFs;
    this.redraw();

    // Force change detection
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.componentId) {
      if (typeof this.newFilterService.unRegisterWidgetData === 'function') {
         this.newFilterService.unRegisterWidgetData(this.componentId);
      }
    }
    this.reqSubcription.forEach(sub => sub.unsubscribe());
  }
}